import { apiRequest } from '@/lib/apiClient';
import type { Role, UserDto } from '@/types';

export interface CreateUserPayload {
  displayName: string;
  username: string;
  password: string;
  role: Role;
}

export const listUsers = () => apiRequest<UserDto[]>('/api/users');
export const createUser = (payload: CreateUserPayload) =>
  apiRequest<UserDto>('/api/users', { method: 'POST', body: payload });
export const updateUserRole = (id: string, role: Role) =>
  apiRequest<void>(`/api/users/${id}/role`, { method: 'PUT', body: { role } });
export const deleteUser = (id: string) =>
  apiRequest<void>(`/api/users/${id}`, { method: 'DELETE' });
